import { render, staticRenderFns } from "./previewBatchModal.vue?vue&type=template&id=bb6597e8&"
import script from "./previewBatchModal.vue?vue&type=script&lang=js&"
export * from "./previewBatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports